import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleDetalhes(e) {
    const atividadeId = e.target.dataset.value;
    const descricaoAtividadeElem = document.getElementById(atividadeId);
    if (descricaoAtividadeElem) {
      if (descricaoAtividadeElem.style.display === 'none' || getComputedStyle(descricaoAtividadeElem).display === 'none') {
        descricaoAtividadeElem.style.display = 'inline';
      } else {
        descricaoAtividadeElem.style.display = 'none';
      }
    }
  }
}